import React from 'react';
import SlideShow from '~/App/shared/components/SlideShow';
import Auction from '~/App/shared/interfaces/Auction';
import { ProductCardVariant } from '~/App/shared/components/ProductCard/types';
import ProductCard from '~/App/shared/components/ProductCard/ProductCard';

interface Props {
  auctions: Auction[];
  productCardVariant?: ProductCardVariant;
}

const AuctionsSlideShow = ({
  auctions = [],
  productCardVariant = ProductCardVariant.Regular
}: Props) => {
  if (auctions.length === 0) {
    return null;
  }

  return (
    <SlideShow>
      {auctions.map((auction: Auction, index) => (
        <ProductCard
          key={`slide-product-${auction.id}-${index}`}
          auction={auction}
          variant={productCardVariant}
        />
      ))}
    </SlideShow>
  );
};

export default AuctionsSlideShow;
